import { render, staticRenderFns } from "./AttributePerson.vue?vue&type=template&id=30e5cc78&scoped=true&"
import script from "./AttributePerson.vue?vue&type=script&lang=js&"
export * from "./AttributePerson.vue?vue&type=script&lang=js&"
import style0 from "./AttributePerson.vue?vue&type=style&index=0&id=30e5cc78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e5cc78",
  null
  
)

export default component.exports